import useGetLanguages from './useGetLanguages'

export default useGetLanguages
